import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../../common/AutoBindComponent";
import unsavedDataDialogHandler from "../../common/UnsavedDataDialogHandler";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/layoutActions";
import * as beads from "../../../actions/beadActions";

import OpbrengstenForm from "./OpbrengstenForm";
import OpbrengstenPageHelper from "./OpbrengstenPageHelper";
import redirector from '../../../util/redirector';
import ConfirmModal from "../../common/ConfirmModal";

class OpbrengstenPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

        this.pageHelper = new OpbrengstenPageHelper(this, redirector);
    }

    componentWillReceiveProps(nextProps) {
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    handleOnDeleteOpbrengstKostInvestering(event, id) {
        this.pageHelper.deleteOpbrengstKostInvestering(id);
    }

    handleOnShowDeleteModal(event, id) {
        window.parent.scrollTo(0, 450);
        this.pageHelper.openModal(id);
    }

    handleOnEditOpbrengstKostInvestering(event, id) {
        this.pageHelper.goToOpbrengstEditWijzig(id);
    }

    render() {
        if (!this.pageHelper.isReadyToRender())
            return null;
        return (<div>
            <ConfirmModal
                hookToTop
                isOpen={this.state.modalIsOpen}
                mainText="Ben je zeker dat je deze opbrengstenpost wil verwijderen?"
                confirmAction={() => this.pageHelper.deleteOpbrengstKostInvestering()}
                cancelAction={() => this.pageHelper.closeModal()}
                confirmText="Verwijder"
                cancelText="Annuleer" />
            <OpbrengstenForm
                color={types.COLOR_PINK_LIGHT}
                model={this.state.financieelOpbrengsten}
                okiTypes={this.props.okiTypes}
                showDeleteModal={this.handleOnShowDeleteModal}
                goToOpbrengstEdit={() => this.pageHelper.goToOpbrengstEdit()}
                goToOpbrengstEditWijzig={this.handleOnEditOpbrengstKostInvestering}
            />
        </div>);
    }
}

OpbrengstenPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
    const dossierId = ownProps.params.dossierId;

    return {
        dossierId: dossierId,
        okiTypes: state.referentie.typeOpbrengstKostInvesteringen
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadFinancieelPageLayout, dispatch),
        beadsLoaded: bindActionCreators(beads.beadsLoaded, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(OpbrengstenPage));